<template>
  <div class="accountManagement">
    <header>
      <el-button
        type="primary"
        style="margin-right: 30px;"
        @click="$refs.addNoval.open()"
      >添加小说</el-button>
      <el-input
        v-model="novalListQuery.novel_name"
        style="max-width: 200px; margin-right: 18px"
        placeholder="小说名称"
      />
      <el-autocomplete
        v-model="pintai"
        style="margin-right: 10px"
        :fetch-suggestions="querySearchAsync"
        placeholder="平台"
        @select="handleSelect1"
      />

      <el-select v-model="novalListQuery.deleted_at" placeholder="请选择状态">
        <el-option
          v-for="item in options"
          :key="item.deleted_at"
          :label="item.label"
          :value="item.deleted_at"
        />
      </el-select>
      <el-button
        type="primary"
        icon="el-icon-search"
        @click="handleSearch"
      >搜索</el-button>
      <el-button
        type="primary"
        icon="el-icon-refresh"
        @click="handleReset"
      >重置</el-button>
    </header>
    <main>
      <el-table
        v-loading="loading"
        :data="tableData.list"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="name"
          label="小说名称"
          min-width="150"
        />
        <el-table-column
          prop="lead"
          label="主角"
          min-width="180"
        />
        <el-table-column
          prop="platform_name"
          label="平台名称"
          min-width="150"
        />
        <!-- <el-table-column label="操作" min-width="80" align="center">
          <template slot-scope="scope">
            <el-button size="mini" @click="$refs.updateWindow.open(scope.row)">编辑</el-button>
          </template>
        </el-table-column> -->
        <el-table-column
          prop=""
          label="操作"
          min-width="60"
        >
          <template slot-scope="scope">
            <el-button :type="scope.row.deleted_at === 0 ? 'primary' : 'info'" size="mini" @click="abandon(scope.row)">{{ (scope.row.deleted_at === 0) ? '替换' : '已替换' }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </main>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <add-noval
      ref="addNoval"
      :platform-data="platformData"
      @confirm="getConfirmData"
    />
    <Abandon ref="abandon1" :platform-data="platformData" @quedin="getListData()" />
    <WasteInformation ref="wasteInformation" />
  </div>
</template>

<script>
// import { getList, modify, getURL } from '@/api/report/accountManagement'
import addNoval from './components/addNoval.vue'
import PaginationRight from '@/components/PaginationRight/index.vue'
import { getList, addNovalList, platformFiltering } from '@/api/report/novalList.js'
import Abandon from './components/abandon.vue'
import WasteInformation from './components/wasteInformation.vue'
export default {
  name: 'NovalList',
  components: {
    PaginationRight,
    addNoval,
    Abandon,
    WasteInformation
  },
  data() {
    return {
      options: [{
        deleted_at: 1,
        label: '替换'
      }, {
        deleted_at: 2,
        label: '已替换'
      }],
      tableData: {}, // 小说列表数据
      flag: false,
      total: null,
      authorizeURL: null,
      // 小说列表请求数据
      novalListQuery: {
        novel_name: null,
        page: null,
        page_size: null,
        platform_id: null,
        deleted_at: null
      },
      // 平台列表数据
      platformData: [],
      loading: null, // 加载效果
      dialogVisible: false,
      pintai: null
    }
  },
  created() {
    this.getListData()
  },
  methods: {
    // 获取小说列表数据
    getListData() {
      this.loading = true
      getList(this.novalListQuery).then(res => {
        this.tableData = res.data
        this.total = res.data.total
        this.platformData = res.data.platform
        this.loading = false
      })
    },
    // 添加小说
    addNovalListData(e) {

    },
    // 搜索小说
    handleSearch() {
      this.novalListQuery.page = 1
      this.getListData()
    },
    // 重置搜索框
    handleReset() {
      this.novalListQuery = {}
      this.pintai = null
      this.getListData()
    },
    // 分页
    fetchPageSize(e) {
      this.novalListQuery.page_size = e
      this.getListData()
    },
    fetchCurrentPage(e) {
      this.novalListQuery.page = e
      this.getListData()
    },
    // 确认添加小说
    getConfirmData(e) {
      addNovalList(e).then(res => {
        this.$message({
          message: '添加成功',
          type: 'success'
        })
        this.getListData()
      })
    },
    async abandon(item) {
      if (item.deleted_at === 0) {
        this.$refs.abandon1.open(item)
      } else {
        this.$refs.wasteInformation.open(item.id)
      }
    },
    async querySearchAsync(queryString, callback) {
      var list = [{}]
      const response = await platformFiltering()
      for (const i of response.data.list) {
        i.value = i.name // 想要展示的数据 // 将想要展示的数据作为value
      }
      list = response.data.list
      callback(list)
    },
    handleSelect1(item) {
      this.novalListQuery.platform_id = item.id
    }
  }
}
</script>

<style scoped lang="less">
.accountManagement {
  min-width: 1200px;
  padding: 30px 60px;
  header {
    display: flex;
    margin-bottom: 20px;
    .el-select {
      margin-right: 20px;
    }
  }
}
</style>
